module.exports = __webpack_public_path__ + "static/media/cog.cc1fb163.svg";